"use client";
import React from "react";
import Image from "next/image";
import { IMAGES } from "@/lib/constants";
import LoanStatusCard from "./loan-status-card";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

const LoanStatusList = ({ loanStatusData, isLoading }) => {
  const t =useTranslations("Dashboard");
  return (
    <>
      {isLoading && <Typography>Loading....</Typography>}
      {!isLoading &&
        loanStatusData?.data?.loanStatusData &&
        loanStatusData?.data?.loanStatusData[0]?.loanTitle !== null && (
          <Stack gap={1}>
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Image src={IMAGES.leftWindow} alt="Hero" />
              <Typography variant="h6">{t("loanstatus")}</Typography>
            </Stack>
            <Box
              sx={{
                display: "flex",
                overflowX: "auto",
                p: 2,
                gap: 4,
              }}
            >
              {loanStatusData?.data?.loanStatusData?.map((loan) => (
                <Box key={loan.appId}>
                  <LoanStatusCard {...loan} />
                </Box>
              ))}
            </Box>
          </Stack>
        )}
    </>
  );
};

export default LoanStatusList;
